<template>
    <div
        class="document form-group"
        :class="{ 'is-empty': empty, 'is-disabled': readonly }"
        :data-element="element.id"
        :title="readonly ? $t('app.common.readonly') : ''"
    >
        <div class="d-flex justify-content-between align-items-center">
            <label class="element-label" :class="classes('title')" :title="required ? trans('buttons.required') : ''">
                <span v-html="macro(label)"></span>
                <small v-if="required" class="required">*</small>
            </label>
            <div v-if="fieldVisibleOnlyInPreview" class="app--engagement-advisor-preview-icon ms-2">
                <app-icon :title="trans('visibility.field.preview')" value="eye" type="fas" class="fa-sm" />
            </div>
        </div>
        <div class="document-row" :class="{ 'is-invalid': !valid }">
            <field-document
                :classes="classes('input')"
                :placeholder="label"
                :value="value"
                :validate-type="filetypes"
                :validate-max-files="maxFiles"
                :enabled="!loading && !readonly"
                :t-drop-to-upload="trans('buttons.droptoupload')"
                :t-upload="trans('buttons.upload')"
                :t-remove="trans('buttons.remove')"
                :t-add-more="trans('buttons.add_more')"
                @update:value="update"
                :key="element.id"
                :data-uploader-id="element.id"
            ></field-document>
        </div>
        <input
            type="text"
            ref="input"
            class="position-absolute invisible"
            :value="value.length > 0 ? 'v' : ''"
            v-validate="validate"
        />
        <div class="invalid-feedback" :for="label" :class="{ 'd-block': !valid }">
            <span v-if="!valid">{{ $t('validation.mandatory') }}</span>
        </div>
        <small class="form-text" :class="classes('description')">
            <span v-if="description" v-html="macro(description)"></span>
            &nbsp;
        </small>
    </div>
</template>

<script>
    import store from '../../store'
    import Document from '../../../components/Document'

    export default {
        props: {
            definition: { type: Object, required: true },
            element: { type: Object, required: true }
        },
        computed: {
            description() {
                return typeof this.definition.description == 'string' ? this.definition.description : null
            },
            empty() {
                return this.value.length <= 0
            },
            saved() {
                return this.element && this.element.value && this.element.value && this.element.value.length > 0
            },
            label() {
                return this.definition.title
            },
            loading() {
                return store.state.loading
            },
            preview() {
                return store.state.preview == true
            },
            readonly() {
                return store.getters.readonly(this.definition, this.saved)
            },
            required() {
                return this.options('required') == true
            },
            valid() {
                return !(this.element && this.element.valid === false)
            },
            filetypes() {
                let ft = this.options('filetypes')

                return ft
                    ? ft.join(',')
                    : [
                          '.bmp',
                          '.csv',
                          '.doc, .docx',
                          '.gif',
                          '.jpg, .jpeg',
                          '.pdf',
                          '.png',
                          '.ppt, .pptx',
                          '.txt',
                          '.xls, .xlsx',
                          '.zip'
                      ].join(',')
            },
            maxFiles() {
                let mf = this.options('max_files')
                return mf ? mf : 10
            },
            fieldVisibleOnlyInPreview() {
                return (
                    this.definition.print_visibility == 'preview' &&
                    store.state.preview == true &&
                    store.state.complete == false
                )
            }
        },
        data() {
            return { value: '' }
        },
        watch: {
            'element.value': {
                immediate: true,
                handler(value) {
                    this.value =
                        value && value instanceof Array
                            ? value.map((v, i) => {
                                  v.url = v.name ? this.url(v.name, i) : null
                                  return v
                              })
                            : []
                }
            }
        },
        methods: {
            classes(index) {
                return store.getters['classes'](index)
            },
            macro(value) {
                return store.getters['macro'](value)
            },
            options(value) {
                return store.getters['options'](this.definition, value)
            },
            trans(value) {
                let trans = store.getters.trans(value)
                return trans ? trans : this.$t('front.' + value)
            },
            update(value) {
                if (!this.readonly) {
                    let payload = value ? value : ''
                    let gk = this.element.group + '|' + this.definition.group
                    store.commit('QUEUE', { id: this.element.id, group: gk, value: payload, upload: value != '' })
                }
            },
            url(name, index) {
                let path = this.preview ? '/app/engagements/file/' : '/e/media/file/'
                return path + store.state.id + '/' + this.element.id + '/' + index + '/' + name
            },
            validate(event) {
                if (this.required) {
                    let m = ''
                    if (event.target.value.length <= 0) {
                        m = this.$t('validation.required', { attribute: this.label })
                    }
                    event.target.setCustomValidity(m)
                }
            }
        },
        components: { 'field-document': Document }
    }
</script>
